// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customTabWrapper .ant-tabs-nav {
  background-color: #efefef !important;
}

.customTabWrapper .ant-tabs .ant-tabs-tab+.ant-tabs-tab {
  margin: 0 0 0 7px !important;
}

.tabStylesListActions {
  display: "flex"; 
  padding: 8px 1px;
  align-items: center;
}
@media screen and (max-width: 800px) {
  .tabStylesListActions {
   display: flex;
   flex-direction: column;  
  }
  .barStyles-last-item{
    position: absolute;
    top: 10px;
    right: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/ModuleNavigation/temp.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;GACC,aAAa;GACb,sBAAsB;EACvB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;AACF","sourcesContent":[".customTabWrapper .ant-tabs-nav {\r\n  background-color: #efefef !important;\r\n}\r\n\r\n.customTabWrapper .ant-tabs .ant-tabs-tab+.ant-tabs-tab {\r\n  margin: 0 0 0 7px !important;\r\n}\r\n\r\n.tabStylesListActions {\r\n  display: \"flex\"; \r\n  padding: 8px 1px;\r\n  align-items: center;\r\n}\r\n@media screen and (max-width: 800px) {\r\n  .tabStylesListActions {\r\n   display: flex;\r\n   flex-direction: column;  \r\n  }\r\n  .barStyles-last-item{\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 5px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
